import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    identifier: { type: String }
  }

  eventName = `${this.identifierValue}:time-range-changed`

  connect() {
    this.element.addEventListener(this.eventName, this.handleTimeRangeChange.bind(this))
  }

  disconnect() {
    this.element.removeEventListener(this.eventName, this.handleTimeRangeChange.bind(this))
  }

  handleTimeRangeChange() {
    // A regular submit() does not work well with Turbo.
    this.element.requestSubmit()
  }
}
